import {DataStrategy} from './DataStrategy';
import {GnTableComponent} from './table.component';

export class LocalDataStrategy implements DataStrategy {

  constructor(private table: GnTableComponent) {
  }

  delete(url: string, ids: any[]): Promise<any> {
    const deletedData = [];
    ids.forEach(id => {
      const data = this.table.data.find(dt => dt[this.table.dataKey] === id);
      deletedData.push(data);
      const index = this.table.data.findIndex(dt => dt === data);
      this.table.data.splice(index, 1);
    });
    return Promise.resolve(deletedData);
  }

  load(): Promise<any> {
    return Promise.resolve({content: this.table.data, totalElements: this.table.dataTotal});
  }

  save(url: string, data: any): Promise<any> {
    return Promise.resolve(data);
  }

}
